import { Permissions } from '../../../../models/enums/permissions';
import * as React from 'react';
import { useStore } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { getDocumentHelper } from '../../../../actions/utility-actions';
import { PageBody } from '../../../../components/page-components/PageBody';
import { PageContent } from '../../../../components/page-components/PageContent';
import { PageHeading } from '../../../../components/page-components/PageHeading';
import { PagedList } from '../../../../components/paged-list/PagedList';
import { HasPermission } from '../../../../containers/authorization-helpers/HasPermission';
import { useSearchParams } from '../../../../hooks/use-search-params';
import { PagedApiResult } from '../../../../models/utilities/paged-request';
import { DealerSvc } from '../../../../shared/services/dealer-service';
import { StatusCode } from '../../../../utils/api';
import { PageNames, Routes } from '../../../../utils/app-constants';
import * as supportActions from '../../../../support/actions';
import { DealerSummary } from '../components/dealer-summary';
import { DealerSearchFilters } from '../../../../support/models/dealers/dealer-search-filters';
import { DocumentDealerExport } from '../../../../support/models/dealers/document-dealer-export';
import { getDealerSearchFilters } from '../../../../support/selectors';
import { useDispatch } from 'react-redux';

export const DealersScene = () => {
   
    const dispatch = useDispatch();
    const store = useStore();
    const [service] = React.useState(new DealerSvc());
    const [filterParams, setFilterParams] = React.useState(() => {
        return getDealerSearchFilters(store.getState());
    });

    const [dealers, setDealers] = React.useState(() => {
        const initial = new PagedApiResult<DealerSummary>();
        initial.pagination = filterParams.paginationInfo;
        initial.pagination.reusePaging = true;
        return initial;
   });
   
   useSearchParams(
       Routes.SUPPORT_USER_EDIT,
       supportActions.updateDealerSearchFilters(filterParams),
       supportActions.clearDealerSearch()
   );

    /**
     * OnSearch handler
     * @param filters The user search filters to apply
     */
    const onSearch = async (filters: DealerSearchFilters) => {
        if (filters.appliedFilters.length > 0) {
            const response = await service.search(DealerSummary, filters);
            if (response.status === StatusCode.Success) {
                setDealers(response.data);   
            }

            setFilterParams(filters);
        }
    };

    const onParamsUpdate = (itm : any) => {
        setFilterParams(itm);
    };

    const onParamsReset = () => {
        const tmp = new DealerSearchFilters();
        setFilterParams(tmp);
    };

    const exportDealers = async () => {
        const req = new DocumentDealerExport();
        dispatch(getDocumentHelper(req));
    }

    return <PageContent pageName={PageNames.SUPPORT_DEALERS_LIST}>
                <PageHeading>
                    <div className="planning-button-list">
                    <HasPermission requiredPermissions={[
                    Permissions.SupportDealersView
                ]}>
                    <button 
                        onClick={ () => exportDealers() }
                        className="btn new attention auto-width">
                        Export
                    </button>
                </HasPermission>                    </div>
                </PageHeading>
                <PageBody>
                    <PagedList
                        noResultsMessage="No dealers found, please search again."
                        searchCallback={ onSearch }
                        data={ dealers }
                        filterProps={ filterParams }
                        selectableClass=""
                        onFilterUpdate={ onParamsUpdate }
                        onReset={ onParamsReset }
                        rowRenderer={(dealer: DealerSummary) => 
                            <tr key={dealer.id}>
                                <td>
                                    <NavLink to={Routes.SUPPORT_DEALERS_WITH_ID.formattify(dealer.id)}>
                                        {dealer.id}
                                    </NavLink>
                                </td>                                    
                                <td>{ dealer.name }</td>
                                <td>{ dealer.city }</td>
                                <td>{ dealer.state }</td>
                            </tr>
                        }
                    />                     
                </PageBody>
            </PageContent>;
};
